import { Flex, Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

export const PermissionsTabLabel = ({ active }: { active: number }) => {
  const { t } = useTranslation()

  return (
    <Flex gap={8} align="center">
      {t('permissions.tab_permissions')}

      <Tag bordered={false} color={active ? 'red' : 'default'}>
        {active}
      </Tag>
    </Flex>
  )
}

export const PermissionsCountBadge = ({
  active,
  total
}: {
  active: number
  total: number
}) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  return (
    <Tag color={active ? 'red' : 'default'} className={styles.code}>
      {t('permissions.count_badge', { active, total })}
    </Tag>
  )
}

export const PermissionsTotalText = ({ active }: { active: number }) => {
  const { t } = useTranslation()

  return (
    <Typography.Text type="secondary">
      {t('permissions.total_active', { total: active })}
    </Typography.Text>
  )
}
